module.exports = __webpack_public_path__ + "img/1F1F3-1F1E6.63990d6a.svg";